<template>
  <div>
    <div v-show="!tidianShow" id="information">
      <div class="m-information">
        <div class="leftt">
          <div class="lefttop">
            <div class="u-toptilte">
              <p><i style="color: #ffcc00">▎</i>账户余额</p>
              <!-- <el-button
                @click="isdialogVisible = true"
                type="warning"
                round
                :disabled="receive_award"
                :style="
                  this.receive_award != true
                    ? 'font-weight: 400;padding:6px 15px;font-size:16px;margin-right:10px; background-image: linear-gradient(270deg,rgba(244, 201, 29, 1) 0%,rgba(255, 242, 130, 1) 100%);border-radius:5px;color:black;'
                    : 'font-weight: 400;padding:6px 15px;font-size:16px;margin-right:10px;'
                "
                >领赠点</el-button
              >-->
              <el-button
                style="
                  opacity: 0;
                  font-weight: 400;
                  padding: 6px 15px;
                  font-size: 16px;
                  margin-right: 10px;
                  background-color: #afafaf;
                  color: #fff;
                  border-color: #afafaf;
                "
                >领赠点</el-button
              >
              <el-dialog
                :title="`第${s + 1}/10题`"
                :visible.sync="isdialogVisible"
                width="36%"
                :before-close="handleClose"
                :show-close="false"
                style="color: red"
              >
                <div class="elall_black" @click="quxiao"></div>
                <div
                  id="Question"
                  v-for="(item, index) in filteredItems"
                  :key="index"
                  style="padding-top: 20px"
                >
                  <h3
                    class="qut_h3"
                    style="color: #000; font-size: 20px; margin: 0 auto"
                  >
                    {{ item.title }}
                  </h3>
                  <ul>
                    <li
                      class="selectItem"
                      v-for="(v, i) in item.selectList"
                      :key="i"
                      @click="slItem(i, v, $event)"
                      :class="isItem == i ? selecla : ''"
                      ref="liId"
                    >
                      {{ v.select }}
                      <p class="sele_cuo">别气馁,在试一次!</p>
                    </li>
                  </ul>
                </div>
                <div class="di">
                  <!-- <el-button style="margin-top: 12px;margin-right:30px;" @click="next">{{content}}</el-button>
                  <el-button style="margin-top: 12px;" @click="quxiao">取消</el-button>-->
                </div>
              </el-dialog>
              <div class="tishi">
                <el-dialog
                  title="提示"
                  :visible.sync="isknow"
                  width="30%"
                  :before-close="handleClose"
                  :show-close="false"
                  class="tishi"
                  @click="guanbi"
                >
                  <span style="color: #fff">恭喜你,拿到6海星点</span>
                  <!-- 选择题 确认提交按钮 -->
                  <!-- <el-button @click="quxiao" type="primary">我知道了</el-button> -->
                </el-dialog>
              </div>
              <el-popover
                v-if="!mobile_flag"
                placement="bottom"
                width="250"
                trigger="click"
                popper-class="popper-class-override"
              >
                <div class="qrcode-box">
                  <img
                    draggable="false"
                    class="recharge-qrcode-img"
                    v-show="rechargeQRCodeUrl"
                    :src="rechargeQRCodeUrl"
                    alt="充值二维码"
                  />
                </div>
                <div class="recharge-desc-box">
                  <div class>请使用手机扫描二维码</div>
                  <div>打开充值</div>
                </div>
                <a
                  slot="reference"
                  @click="chongzhi"
                  class="u-btnzx"
                  style="padding: 0 10px"
                  >去充值</a
                >
                <!-- <el-button
                  class="o2"
                  slot="reference"
                  style="border-radius:26px;"
                  @click="Rechargeing"
                >
                  <i class="iconfont">&#xe67b;</i>&nbsp;&nbsp;充值
                </el-button>-->
              </el-popover>
              <a
                v-else
                @click="chongzhi"
                class="u-btnzx"
                style="padding: 0 10px"
                >去充值</a
              >
              <!-- <div class="pop" v-show="visible && !mobile_flag">
                <div id="qr_code" class="payCode"></div>
                <div class="tip">请使用手机扫描二维码完成支付</div>
              </div>-->
            </div>
            <section class="balances">
              <img draggable="false" src="../../static/percttent/hxd.png" />
              <el-form style="width: 50%">
                <el-form-item label="海星点：" label-width="100px">
                  <i class="fr">{{ balance }}</i>
                </el-form-item>
                <el-form-item
                  label="赠点："
                  label-width="100px"
                  style="margin-bottom: 0"
                >
                  <i class="fr">{{ jifen }}</i>
                </el-form-item>
              </el-form>
            </section>
          </div>
          <div class="lefttop">
            <div class="u-toptilte">
              <p><i style="color: #ffcc00">▎</i>您的信息</p>
              <img
                :src="vipa"
                v-if="vipa"
                draggable="false"
                style="height: 30px"
              />
              <span v-else>{{ vipLevelText }}</span>
              <a
                slot="reference"
                v-if="!mobile_flag"
                @click="dialogVisible2 = true"
              >
                <img
                  draggable="false"
                  src="../assets/images/help.png"
                  style="cursor: pointer"
                  title="vip权益说明"
                />
              </a>
              <a slot="reference" v-else @click="dialogVisible = true">
                <img draggable="false" src="../assets/images/help.png" />
              </a>
            </div>
            <el-form
              style="padding: 25px 0 0 23px"
              label-position="right"
              label-width="90px"
            >
              <el-form-item label="登录ID：">
                <i class="fr">{{ phone }}</i>
              </el-form-item>
              <el-form-item label="手机号：">
                <i class="fr">{{ phone }}</i>
              </el-form-item>
              <el-form-item label="姓名：">
                <i class="fr">{{ name }}</i>
              </el-form-item>
              <el-form-item label="身份证号：">
                <i class="fr">{{ shiming }}</i>
              </el-form-item>
              <el-form-item label="邀请充值：">
                <i
                  @click="CZcopy"
                  class="fr invite"
                  type="primary"
                  size="small"
                  v-clipboard:copy="key"
                  v-clipboard:success="onCopy"
                  v-clipboard:error="onError"
                >
                  复制
                  <i class="el-icon-copy-document"></i>
                </i>
                <img v-show="inviteReacge" :src="inviteReacge" alt />
              </el-form-item>
              <el-form-item label="邮箱：">
                <i class="fr">{{ email }}</i>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <div class="rightt">
          <div class="u-toptilte">
            <p><i style="color: #ffcc00">▎</i>邀请返现</p>
          </div>

          <div class="yaoqingma">
            <!-- <div id="qrcode"></div> -->
            <div class="invitation-img-box">
              <img
                draggable="false"
                class="invitation-img"
                :src="invitationUrl"
                v-if="invitationUrl"
              />
            </div>
          </div>

          <el-form>
            <el-row>
              <el-col>
                <el-form-item label="邀请码：" class="lables">
                  <div class="zz-About">
                    <span id="invaCation">{{ Invitation }}</span>
                    <span
                      style="position: absolute; top: -99999px"
                      id="invaCationLink"
                      >https://www.haixingcloud.com/#/Home?invtecode={{
                        Invitation
                      }}</span
                    >
                    <span
                      class="copyLink"
                      @click="copyHandler"
                      draggable="false"
                      >复制</span
                    >
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col>
                <el-form-item label="共邀请人数：" class="lables">
                  <div>{{ Invitations }}</div>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col>
                <el-form-item label="共邀请充值人数：" class="lables">
                  <div>{{ Invitationcz }}</div>
                </el-form-item>
                <el-form-item label="邀请奖励金：" class="lables">
                  <div class="zz-About">
                    <span>{{ Invate_bonus }}</span>
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
            <br />
            <el-row>
              <el-col>
                <el-form-item class="lablesb">
                  <div class="bt-group">
                    <a @click="withdrawalDialogVisible=true" class="u-btnzx tixian">提现</a>
                    <a @click="tidianShow = true" class="u-btnzx tidian"
                      >提点</a
                    >
                    <a @click="recording" class="lablesb-record">记录</a>
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <div class="Recordcontent" v-show="yincang">
            <div style="background: rgba(156, 165, 236, 0.1)">
              <div class="R_back" @click="R_back">返回</div>
            </div>
            <div id="cashback">
              <div class="u-toptilte">
                <p><i style="color: #ffcc00">▎</i>提现记录</p>
              </div>
              <ul class="CB_title">
                <li>提现点数</li>
                <li>提现描述</li>
                <li>提现时间</li>
              </ul>
              <div
                v-for="(item, index) in withdraw"
                :key="index"
                class="CB_content"
              >
                <span>{{ item.num }}</span>
                <span>{{ item.desc }}</span>
                <span>{{ item.createdat_str }}</span>
              </div>
              <div class="u-btnpage">
                <span>共{{ cur_total_page }}页</span>
                <span>当前{{ cur_cur_page }}页</span>
                <a @click="previouspage">上一页</a>
                <a @click="nextpage">下一页</a>
              </div>
            </div>
            <div id="cashback" style="margin-top: 20px">
              <div class="u-toptilte">
                <p><i style="color: #ffcc00">▎</i>返现记录</p>
              </div>
              <ul class="CB_title">
                <li>返现点数</li>
                <li>返现描述</li>
                <li>返现时间</li>
              </ul>
              <div
                v-for="(item, index) in wdlist"
                :key="index"
                class="CB_content"
              >
                <span>{{ item.num }}</span>
                <span>{{ item.desc }}</span>
                <span>{{ item.createdat_str }}</span>
              </div>
              <div class="u-btnpage">
                <span>共{{ wd_total_page }}页</span>
                <span>当前{{ wd_cur_page }}页</span>
                <a @click="isup">上一页</a>
                <a @click="isdown">下一页</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-show="tidianShow" class="secur-ity m-consumption">
      <div class="u-toptilte">
        <p><i style="color: #ffcc00">▎</i>提点中心</p>
        <a @click="tidianShow = false" class="u-btnzx back-tixian">返回</a>
      </div>
      <div>
        <div class="form">
          <el-form
            label-width="160px"
            :label-position="mobile_flag ? 'top' : 'right'"
          >
            <el-row>
              <el-col :span="12">
                <el-form-item label="我的邀请奖励金：">
                  <div>{{ Invate_bonus }}</div>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row type="flex" align="bottom">
              <el-col :span="12">
                <el-form-item label="提现点数：">
                  <el-input
                    placeholder="请输入提现点数"
                    type="number"
                    @change="verificationa"
                    v-model.number="shuru.num"
                  ></el-input>
                  <div class="el-form-item__error">
                    {{ cuowuspan.Verification }}
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="1">
                <el-form-item>
                  <el-button
                    class="u-btnzx"
                    type="warning"
                    :disabled="!available"
                    @click="send"
                    style="margin-left: 10px; width: 90px; height: 40px"
                    >确认</el-button
                  >
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </div>
    </div>
    <el-dialog
      :visible.sync="dialogVisible"
      width="99%"
      :before-close="handleClose"
    >
      <span class="rules" v-html="vipInstructionsText"> </span>
    </el-dialog>
    <el-dialog
      title=""
      :visible.sync="dialogVisible2"
      :before-close="handleClose"
      custom-class="dialogclass"
    >
      <div v-html="vipInstructions"></div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible2 = false">我知道了</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="提现申请"
      :visible.sync="withdrawalDialogVisible"
    >
      开户行信息:<el-input v-model="bank_info" placeholder="XX银行XX支行"></el-input>
      开户行账号:<el-input v-model="bank_account" placeholder="62XXXXXXXXXXXXXXXX"></el-input>
      提现金额:<el-input v-model="amount" placeholder="100-800"></el-input>
      <br><br><br><br>
      <a @click="postWithdrawal()" class="u-btnzx" id="withdrawal-post">提交申请</a>
    </el-dialog>
  </div>
</template>

<script>
import adaption from '@/mixi/adaption'
import QRCode from 'qrcode'
import {
  default as swal
} from 'sweetalert2'
export default {
  // 接收注入的数据
  inject: [
    'reload'
  ],
  mixins: [adaption],
  data () {
    return {
      // 答题
      chooseNumStr: '',
      timer: null,
      s: 0,
      selecla: '',
      isknow: false,
      isItem: -1,
      content: '下一题',
      // active: 0,
      // n: 0,
      isdialogVisible: false,
      // 问题列表
      questionList: [
        {
          title: '1.界面闪退，无法进入画面，或显示启动异常？',
          selectList: [
            {select: 'A. PC：进入设置，设置为强制264  安卓：设置选择禁用265'},
            {select: 'B. 在群里谩骂客服'},
            {select: 'C. 换个手机'}
          ],
          isTrue: 'A'
        },
        {
          title: '2.画面发生卡顿，花屏，闪屏等现象？',
          selectList: [
            {select: 'A．睡一会再试，不行砸了'},
            {select: 'B．根据官网的表格，适当设置分辨率，码率与帧数'},
            {select: 'C．到speedtest.net测速并根据官网提示调整设置尝试,并选择正确的线路'}
          ],
          isTrue: 'C'
        },
        {
          title: '3.鼠标速度怎么调？',
          selectList: [
            {select: 'A．鼠标右键左下角windows点击设置-设备-鼠标-其他鼠标选项-指针选项-移动进行调整'},
            {select: 'B．怒砸鼠标'},
            {select: 'C．我只要体验最好的，所有都拉满'}
          ],
          isTrue: 'A'
        },
        {
          title: '4.屏幕只显示半屏怎么解决？',
          selectList: [
            {select: 'A．再接一块显示屏'},
            {select: 'B．按ctrl+alt+shift+q退出到客户端并切换为无边框窗口模式'},
            {select: 'C．只看一般屏幕'}
          ],
          isTrue: 'B'
        },
        {
          title: '5.节点获取失败？',
          selectList: [
            {select: 'A．把网线接海星云服务器上'},
            {select: 'B．烧香祈福'},
            {select: 'C．关闭电脑防火墙，重启路由器和光猫，如果仍然无法进入，建议重装系统'}
          ],
          isTrue: 'C'
        },
        {
          title: '6.怎么从游戏里面切到云电脑桌面？',
          selectList: [
            {select: 'A．ctrl+alt+shift+d 即可返回云电脑桌面'},
            {select: 'B．强制关闭电脑'},
            {select: 'C．重开云电脑'}
          ],
          isTrue: 'A'
        },
        {
          title: '7.游戏异地登录怎么回事？',
          selectList: [
            {select: 'A．坐车去节点本地登录'},
            {select: 'B．云电脑与您的电脑位置不同，所以才显示异地登陆'},
            {select: 'C．关了游戏'}
          ],
          isTrue: 'B'
        },
        {
          title: '8.win7系统打开软件很慢怎么回事？',
          selectList: [
            {select: 'A．换了吧换个系统'},
            {select: 'B．win7系统官方已停止维护，且系统环境杂乱不堪，有很多因素导致无法打开，建议更换win10系统'},
            {select: 'C．换了吧换个系统'}
          ],
          isTrue: 'B'
        },
        {
          title: '9.软件安装之后，提示dll错误或者0x00007c错误？',
          selectList: [
            {select: 'A．进入客服群向客服索要运行库下载链接，并安装'},
            {select: 'B．自行下载未知资源库'},
            {select: 'C．随便下载几个'}
          ],
          isTrue: 'A'
        },
        {
          title: '10.下载文件或更新游戏提示硬盘报错？',
          selectList: [
            {select: 'A．不信邪再试一次'},
            {select: 'B．换一台继续下载'},
            {select: 'C．云电脑有40Gb的下载限制，部分游戏需要检索全部文件，需要后台更新'}
          ],
          isTrue: 'C'
        }
      ],
      // 邀请码二维码图片地址
      invitationUrl: '',
      // 邀请充值二维码图片地址
      inviteReacge: '',
      // 充值二维码图片地址
      rechargeQRCodeUrl: '',
      dialogVisible: false,
      visible: false,
      tidianShow: false,
      vipshuoming: false,
      token: '0',
      balance: '0',
      jifen: '',
      Invate_bonus: '',
      Invitation: '0',
      Invitations: '0',
      Invitationcz: '0',
      name: '',
      idcard: '',
      shiming: '',
      id: '',
      phone: '',
      email: '',
      VIP: '',
      vipa: '',
      shuru: {
        num: ''
      },
      // 错误的提示信息
      cuowuspan: {
        phone: '',
        Verification: ''
      },
      available: false,
      receive_award: null,
      // 提现记录
      withdraw: [],
      // 提现页数
      withdraw_page: 1,
      // 总共页数
      cur_total_page: 0,
      // 当前页数
      cur_cur_page: 0,
      // 返现记录,
      wdlist: [],
      // 返现页数
      wd_page: 1,
      // 总共页数
      wd_total_page: 0,
      // 当前页数
      wd_cur_page: 0,
      // 隐藏
      yincang: false,
      // 复制内容  充值地址
      key: '',
      vipInstructions: '', // vip权益内容
      vipInstructionsText: '',
      vip_level_current: 0, // 用户当前vip等级
      dialogVisible2: false,
      vipLevelText: '',
      withdrawalDialogVisible: false,
      bank_info: '',
      bank_account: '',
      amount: 0
    }
  },
  mounted () {
    document.addEventListener('click', e => {
      if (e.target.text !== '去充值' || this.visible) {
        this.visible = false // 点击其他区域关闭
      } else {
        this.visible = true
      }
    })
    this._cashback()
    this._withdraw()
    // setTimeout(() => { this.key = 'http://localhost:8002/#/pay?userName=&level=&invtecode=' + this.Invitation }, 1000)
  },
  computed: {
    filteredItems: function () {
      return this.questionList.slice(this.s, this.s + 1)
      // return this.questionList.slice(1, 2)
    }
  },
  methods: {
    // vip权益说明 根据对应vip等级对应不同的id查询
    getVipInstructions (id) {
      this.http.chawzid(id).then((res) => {
        if (res.data.code === 200) {
          this.vipInstructions = res.data.data.article.article_content
        }
      })
    },
    // vip当前等级权益-文字说明
    getVipInstructionsText (id) {
      this.http.chawzid(id).then((res) => {
        if (res.data.code === 200) {
          this.vipInstructionsText = res.data.data.article.article_content
        }
      })
    },
    // 复制赋值
    CZcopy () {
      this.key = `http://192.168.50.137:8002/#/pay?userName=&level=&invtecode=${this.Invitation}`
      if (!this.inviteReacge) {
        QRCode.toDataURL(`http://192.168.50.137:8002/#/pay?userName=&level=&invtecode=${this.Invitation}`).then(url => {
          this.inviteReacge = url
        }).catch(err => {
          console.log('生成邀请充值二维码失败')
        })
      }
    },
    // 复制邀请充值链接
    onCopy () {
      // this.key = '123123123
      this.$message({
        message: '复制成功',
        type: 'success'
      })
    },
    onError () {
      this.$message.error('复制失败')
    },
    // 提现记录 提点记录
    recording () {
      this.yincang = true
    },
    R_back () {
      this.yincang = false
    },
    // 返现记录
    _withdraw () {
      this.http
        .withdraw_history('username', this.wd_cur_page).then(res => {
          if (res.data.code === 200) {
            this.wdlist = res.data.data.charge_list
            this.wd_total_page = res.data.data.total_page
            this.wd_cur_page = res.data.data.cur_page
          }
        })
    },
    isup () {
      if (this.wd_cur_page === 1) {
        this.withdraw_page = 1
        this._withdraw()
      } else if (this.wd_cur_page > 1) {
        this.wd_cur_page -= 1
        this._withdraw()
      }
    },
    isdown () {
      if (this.wd_cur_page >= this.wd_total_page) {
        this.wd_cur_page = this.wd_total_page
        this._withdraw()
      } else if (this.wd_cur_page < this.wd_total_page) {
        this.wd_cur_page += 1
        this._withdraw()
      }
    },
    // 请求提现历史记录
    _cashback () {
      this.http
        .CashBack_history('username', this.withdraw_page).then(res => {
          // console.log(res)
          if (res.data.code === 200) {
            this.withdraw = res.data.data.list
            this.cur_total_page = res.data.data.total_page
            this.cur_cur_page = res.data.data.cur_page
          }
        })
    },
    // 下一页
    nextpage () {
      // this.withdraw_page += 1
      // this._cashback()
      if (this.withdraw_page >= this.cur_total_page) {
        this.withdraw_page = this.cur_cur_page
        this._cashback()
      } else if (this.withdraw_page < this.cur_total_page) {
        this.withdraw_page += 1
        this._cashback()
      }
    },
    // 上一页
    previouspage () {
      if (this.withdraw_page === 1) {
        this.withdraw_page = 1
        this._cashback()
      } else if (this.withdraw_page > 1) {
        this.withdraw_page -= 1
        this._cashback()
      }
    },
    // showQue () {
    //   var s = 0
    //   $('#Question').innerHtml = this.questionList[s]
    //   s = s + 1
    // },
    slItem (i, v, event) {
      let vsb = v.select
      console.log(this.$refs.liId[i])
      this.$refs.liId[i].classList.add('sl_pdding')
      this.chooseNumStr = this.$refs.liId[i].innerText.substring(0, 1)
      for (let n = 0; n < this.filteredItems.length; n++) {
        if (this.chooseNumStr === this.filteredItems[n].isTrue) {
          this.isItem = i
          this.selecla = 'dui'
          if (this.selecla == 'dui') {
            setTimeout(() => {
              this.questionList[n].selectList[i].select = vsb
              this.selecla = ''
              this.next()
            }, 500)
          } else {
          }
        } else {
          this.isItem = i
          this.selecla = 'cuo'
          if (this.selecla == 'cuo') {
            event.path[0].childNodes[1].style.display = 'block'
            setTimeout(() => {
              event.path[0].childNodes[1].style.display = 'none'
              this.selecla = ''
            }, 500)
          }
        }
      }
    },
    next () {
      if (this.chooseNumStr === this.questionList[this.s].isTrue) {
        this.s += 1
        this.selecla = ''
        if (this.s === 9) {
          this.content = '提交'
        } else if (this.s > 9) {
          this.isknow = true
          this.isdialogVisible = false
          this.isknow = true
          this.isdialogVisible = false
          this.s = 0
          this.content = '下一题'
          this.http.getAward(this.id)
            .then(res => {
              if (res.status == 200 && res.data.code == 200) {
                this.$message({
                  message: res.data.message,
                  type: 'success'
                })
              } else {
                this.$message.error(res.data.message)
              }
              window.location.reload()
            })
            .catch(e => {
              this.$message.error(e)
            })
        }
      }
    },
    quxiao () {
      this.isdialogVisible = false
      this.isknow = false
      this.selecla = ''
    },
    handleClose (done) {
      done()
    },
    copyHandler () {
      let node = document.getElementById('invaCationLink')
      let range = document.createRange()
      range.selectNodeContents(node)
      let selection = document.getSelection()
      selection.removeAllRanges()
      selection.addRange(range)
      document.execCommand('Copy')
      this.$message({
        message: '复制成功',
        type: 'success'
      })
    },
    showRouter () {
      // 调用reload方法，刷新整个页面
      this.reload()
    },
    send () {
      if (!this.available) return false
      this.http
        .invite_bonus(this.shuru.num)
        .then(res => {
          if (res.status == 200 && res.data.code == 200) {
            this.$message({
              message: '提点成功',
              type: 'success'
            })
            this.showRouter()
          } else {
            this.$message.error('提点失败，请重试！')
          }
        })
    },
    verificationa () {
      if (/^\d+$/.test(this.shuru.num) == false) {
        this.cuowuspan.Verification = '请输入整数'
        this.available = false
      }
      if (this.shuru.num && this.shuru.num * 1 <= this.Invate_bonus && /^\d+$/.test(this.shuru.num)) {
        this.cuowuspan.Verification = ''
        this.available = true
      } else if (this.shuru.num == null || this.shuru.num == '') {
        this.cuowuspan.Verification = '请输入提现点数'
        this.available = false
      } else if (this.shuru.num * 1 > this.Invate_bonus) {
        this.cuowuspan.Verification = '提现点数错误'
        this.available = false
      }
    },
    vipenter () {
      this.vipshuoming = true
    },
    vipleave () {
      this.vipshuoming = false
    },
    chongzhi () {
      let userName = window.localStorage.getItem('user_name')
      let vip_level = window.localStorage.getItem('vip_level')
      // 获取个人信息
      this.http.getUserInfo({token: this.token, username: 'username'}).then(res => {
        console.log()
        let result = {}
        if (res.status !== 200) {
          this.$message.info('获取个人信息请求失败')
          return
        }
        result = res.data
        if (result.code !== 200) {
          this.$message.info(result.$message)
          return
        }
        let token = this.token
        let userInfo = result.data
        let phone = userInfo.phone
        let vipLevel = userInfo.vip_level
        let pay = `https://www.haixingcloud.com:8002/#/pay?userName=${phone}&t=${token}&level=${vipLevel}`
        if (this.mobile_flag) {
          // 手机充值
          window.location.href = pay
        } else {
          // 弹出充值二维码
          if (this.rechargeQRCodeUrl) return
          this.generateQR(pay)
          // this.$QRCodeSC(pay, 80, 80)
          // window.location.href = `${window.location.protocol}//${window.location.host}/#/Rechargeing`
        }
      })
    },

    // 生成二维码图片
    generateQR (pay) {
      QRCode.toDataURL(pay).then(res => {
        this.rechargeQRCodeUrl = res
      }).catch(error => {
        console.warn(error)
        this.$message.info('生成二维码异常')
      })
    },
    jihuozk () {
      // this.$confirm(
      //   '提现最低门槛100元，请于工作日联系客服微信haixingcloud01人工处理，审核后将于三个工作日内发放。',
      //   '提示'
      // )
    },
    postWithdrawal () {
      this.http.postWithdrawal(this.bank_info, this.bank_account, this.amount).then(res => {
        if (res.status === 200 && res.data.code === 200) {
          this.$message({
            message: '提交成功',
            type: 'success'
          })
          this.bank_info = ''
          this.bank_account = ''
          this.amount = 0
          this.withdrawalDialogVisible = false
        } else if (res.status === 200) {
          this.$message.error(res.data.message2)
        } else {
          this.$message.error('提交失败，请重试！')
        }
      })
    },
    jihuozk2 () {
      this.$router.push({
        path: './InviteBonusList'
      })
    },
    chain () {
      // swal.mixin({
      //   confirmButtonText: 'Next &rarr;',
      //   showCancelButton: true,
      //   confirmButtonColor: '#556ee6',
      //   cancelButtonColor: '#74788d',
      //   cancelButtonText: '取消',
      //   progressSteps: ['1', '2', '3']
      // })
      //   .queue(
      //     [{
      //       title: '画面模糊卡顿的原因可能有哪些？（单选）',
      //       html: `<p>A．网络卡顿</p>
      //                       <p>B．设置不当</p>
      //                       <p>C．进错线路</p>
      //                       <p>D．出现bug</p>
      //                       <p>E．以上全部</p>
      //                       `,
      //       input: 'text',
      //       showCancelButton: true,
      //       confirmButtonText: '下一步'
      //     },
      //     {
      //       title: '在进行客户端设置时，哪些是正确的?（多选）',
      //       html: `<p>A．在speedtest.net检测自己的网速，以估计使用设置</p>
      //                       <p>B．根据官网的表格，适当设置分辨率，码率与帧数</p>
      //                       <p>C．我只要体验最好的，所有都拉满</p>
      //                       <p>D．在不确定之前，先将自己的设置调整为软件解码，强制h.264编码，以得到最佳兼容性</p>
      //                       <p>E．根据游玩的体验适当提升或降低设置</p>
      //                       `,
      //       input: 'text',
      //       showCancelButton: true,
      //       confirmButtonText: '下一步'
      //     },
      //     {
      //       title: '当您在游玩时遇到问题，以下哪些方式是正确的?（多选）',
      //       html: `<p>A．我玩不上游戏我就是要疯狂diss客服</p>
      //                       <p>B．私聊客服进行反馈并附上截图或小视频</p>
      //                       <p>C．群内@客服并附上截图或小视频</p>
      //                       <p>D．在公众号提交问题反馈，上传清晰截图或小视频，等待结果</p>
      //                       <p>E．在群内询问其他群友是否有相同问题，寻找临时解决办法，事后反馈</p>
      //                       `,
      //       input: 'text',
      //       showCancelButton: true,
      //       confirmButtonText: '确定'
      //     }

      //     ])
      //   .then(result => {
      //     if (result.value) {
      //       let html = ''
      //       // console.log('result.value: ', JSON.stringify(result.value));
      //       if (result.value[0].length <= 0 || result.value[0].toUpperCase().replace(/[^a-zA-Z]/g, '') !== 'E') {
      //         html = html + '<p>很遗憾，第1题答错了，正确答案是：E</p>'
      //         // swal.fire({
      //         //   title: '提示',
      //         //   html: `很遗憾，第1题答错了`,
      //         //   confirmButtonText: '我知道了'
      //         // })
      //         // return false
      //       }
      //       if (result.value[1].length <= 0 || result.value[1].toUpperCase().replace(/[^a-zA-Z]/g, '') !== 'ABDE') {
      //         html = html + '<p>很遗憾，第2题答错了，正确答案是：ABDE</p>'
      //         // swal.fire({
      //         //   title: '提示',
      //         //   html: `很遗憾，第2题答错了`,
      //         //   confirmButtonText: '我知道了'
      //         // })
      //         // return false
      //       }
      //       if (result.value[2].length <= 0 || result.value[2].toUpperCase().replace(/[^a-zA-Z]/g, '') !== 'BCDE') {
      //         html = html + '<p>很遗憾，第3题答错了，正确答案是：BCDE</p>'
      //         // swal.fire({
      //         //   title: '提示',
      //         //   html: `很遗憾，第3题答错了`,
      //         //   confirmButtonText: '我知道了'
      //         // })
      //         // return false
      //       }
      //       if (html) {
      //         swal.fire({
      //           title: '提示',
      //           html: html,
      //           confirmButtonText: '我知道了'
      //         })
      //         return false
      //       }
      // this.http.getAward(this.id)
      //   .then(res => {
      //     if (res.status == 200 && res.data.code == 200) {
      //       this.$message({
      //         message: res.data.message,
      //         type: 'success'
      //       })
      //     } else {
      //       this.$message.error(res.data.message)
      //     }
      //     window.location.reload()
      //   })
      //   .catch(e => {
      //     this.$message.error(e)
      //   })
      //     }
      //   })
    }
  },
  created () {
    this.token = this.$cookieStore.getCookie('user_sess')
    // console.log(this.$cookieStore.getCookie('user_sess'))
    // console.log(this.token)
    if (!this.token) {
      this.$message({
        message: '抱歉！您还没登录',
        type: 'warning'
      })
      return false
    }
    this.http.gerenzx().then(res => {
      // console.log(res.data.data.vip_level)
      this.$store.commit('addNice', 1)
      this.$store.commit('addVip', res.data.data.vip_level)
      if (res.data.data.active == true) {
        this.shiming = '已认证'
      } else {
        this.shiming = '未认证'
      }
      this.jifen = res.data.data.bonus
      this.Invate_bonus = res.data.data.invite_bonus
      this.email = res.data.data.email
      this.id = res.data.data.user_name
      this.phone = res.data.data.phone
      this.name = res.data.data.full_name
      this.idcard = res.data.data.id_card
      this.balance = res.data.data.userbalance
      this.Invitation = res.data.data.invitationcode.toUpperCase()
      this.Invitations = res.data.data.invitees
      this.Invitationcz = res.data.data.valied_invitees
      this.receive_award = res.data.data.receive_award
      if (this.id) {
        window.localStorage.setItem('user_name', this.id)
      }
      if (res.data.data.vip_level) {
        window.localStorage.setItem('vip_level', res.data.data.vip_level)
      }
      // console.log(`https://haixingcloud.com/#/?invtecode=${this.Invitation}`)
      if (!this.invitationUrl) {
        QRCode.toDataURL(`https://haixingcloud.com/#/?invtecode=${this.Invitation}`).then(url => {
          this.invitationUrl = url
        }).catch(error => {
          this.$message.info('生成邀请码二维码图片失败')
          console.warn('生成邀请码二维码图片失败')
        })
      }
      // this.$QRCodeSC(
      //   'https://haixingcloud.com/#/Register?invitecode=' + this.Invitation,
      //   154,
      //   154
      // )
      if (res.data.data.vip_level == 0) {
        this.VIP = ''
        this.vipa = ''
        this.getVipInstructions(188)
        this.getVipInstructionsText(195)
      } else if (res.data.data.vip_level == 1) {
        this.VIP = '../../static/images/center/vipp1.png'
        this.vipa = '../../static/images/center/VIP1.png'
        this.getVipInstructions(189)
        this.getVipInstructionsText(196)
      } else if (res.data.data.vip_level == 2) {
        this.VIP = '../../static/images/center/vipp2.png'
        this.vipa = '../../static/images/center/VIP2.png'
        this.getVipInstructions(190)
        this.getVipInstructionsText(197)
      } else if (res.data.data.vip_level == 3) {
        this.VIP = '../../static/images/center/vipp3.png'
        this.vipa = '../../static/images/center/VIP3.png'
        this.getVipInstructions(191)
        this.getVipInstructionsText(198)
      } else if (res.data.data.vip_level == 4) {
        this.VIP = '../../static/images/center/vipp4.png'
        this.vipa = '../../static/images/center/VIP4.png'
        this.getVipInstructions(192)
        this.getVipInstructionsText(199)
      } else if (res.data.data.vip_level == 5) {
        this.VIP = '../../static/images/center/vipp5.png'
        this.vipa = '../../static/images/center/VIP5.png'
        this.getVipInstructions(193)
        this.getVipInstructionsText(200)
      } else if (res.data.data.vip_level == 6) {
        this.VIP = '../../static/images/center/vipp6.png'
        this.vipa = '../../static/images/center/VIP6.png'
        this.getVipInstructions(194)
        this.getVipInstructionsText(201)
      } else {
        this.vipLevelText = 'VIP' + res.data.data.vip_level
      }
    })
  }
}
</script>

<style lang="scss" scoped>
@media screen and (max-width: 1024px) {
  #information {
    .el-dialog {
      width: 60% !important;
    }
  }
}
@media screen and (max-width: 768px) {
  #information {
    .el-dialog {
      width: 60% !important;
    }
  }
}
@media screen and (max-width: 425px) {
  #information {
    .el-dialog {
      width: 80% !important;
    }
  }
}

@media screen and (max-width: 1550px) {
  .selectItem {
    width: 300px;
  }
}

.qut_h3 {
  text-align: center;
  color: #fff !important;
}
.el-dialog__title {
  color: #ffffff;
}
/deep/ .el-dialog.dialogclass {
  width: 70%;
  background: #efeee6;
}
#information {
  .el-dialog__body {
    padding: 0 30px 50px;
    // background-color: #304266;
  }
  .el-dialog {
    border-radius: 15px;
    background-color: #304266;
  }
  .el-dialog__header {
    padding-top: 30px;
    display: flex;
    justify-content: center;
    // background-color: #304266;
  }

  .elall_black {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    position: absolute;
    right: 15px;
    top: 15px;
    background-image: url("../../static/􀁑.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }
  .di {
    display: flex;
    justify-content: center;
  }
  .tishi .el-dialog__body {
    padding: 20px;
    display: flex;
    flex-direction: column;
    position: relative;
    align-items: center;
    span {
      margin-bottom: 30px;
      font-size: 20px;
    }
  }
  .selectItem {
    width: 80%;
    min-height: 46px;
    margin: 20px auto 20px;
    padding-left: 10px;
    display: flex;
    align-items: center;
    cursor: pointer;
    text-align: center;
    position: relative;
    border-radius: 12px;
    padding-right: 20px;
    background-image: url("../../static/pt.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    padding-top: 3px;
    padding-bottom: 8px;
    color: #fff;
    line-height: 20px;
    overflow: hidden;
  }
  .selectItem p {
    display: none;
    position: absolute;
    width: 100%;
    height: 100%;
    border-radius: 12px;
    margin-left: -10px;
    margin-top: -3px;
    margin-bottom: -8px;
    background-image: url("../../static/cuo.png");
    padding-right: 30px !important;
    background-color: red;
    background-size: 30px 30px;
    background-position: right 5% top 50%;
    background-repeat: no-repeat;
    line-height: 44px;
    text-align: center;
  }
  .dui {
    background-color: #4ba047;
    // <img src="../../static/percttent/hxd.png" />
    background-image: url("../../static/dui.png");
    color: #fff;
    background-repeat: no-repeat;
    background-size: 30px 30px;
    background-position: right 5% top 50%;
    padding-right: 30px !important;
  }
  .cuo {
    background-color: rgb(226, 25, 25);
    color: #fff;
    display: flex;
    height: 40px;
  }
}
.popper-class-override {
  padding: 20px 0 0 0 !important;
  border: none !important;
  outline: none !important;
  background-color: #25304c !important;
  border-radius: 8px !important;
  /* background: transparent !important; */
  /* min-width: 115px !important; */
}
.popper-class-override .qrcode-box {
  width: 160px;
  height: 160px;
  overflow: hidden;
  margin: 20px auto;
}
.popper-class-override .qrcode-box .recharge-qrcode-img {
  width: 100%;
  height: 100%;
}
.popper-class-override .popper__arrow {
  border-bottom-color: #25304c !important;
}
.popper-class-override .popper__arrow::after {
  border-bottom-color: #25304c !important;
}
.popper-class-override .recharge-desc-box {
  margin-bottom: 30px !important;
  color: #fff !important;
  text-align: center;
}
.rules p {
  text-align: left;
  margin: 0px;
}
.rules .one {
  text-align: left;
  font-weight: 700;
  color: #000;
  font-size: 12px;
  margin-top: 15px;
}
.u-toptilte {
  position: relative;
  margin-bottom: 20px;
}

.pop {
  position: absolute;
  right: -260px;
  top: -1px;
  width: 250px;
  background: #fff;
  border: 1px solid black;
  padding: 12px;
  border-radius: 4px;
  z-index: 1000;

  .tip {
    font-size: 14px;
    text-align: center;
    margin: 0 0 15px;
    color: #606266 !important;
    letter-spacing: 0.5px;
  }

  .payCode img {
    display: block;
    width: 180px;
    height: 180px;
    margin: 20px auto;
    background-color: #fff;
    padding: 6px;
  }
}

.pop::after {
  content: "";
  width: 0;
  height: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  border-right: 10px solid #ffffff;
  position: absolute;
  top: 2px;
  left: -10px;
}

body.swal2-height-auto {
  height: 100% !important;
}

.m-information {
  position: relative;
  .leftt {
    display: inline-block;
    vertical-align: top;
  }
  .rightt {
    display: inline-block;
    vertical-align: top;
  }
  .el-form-item {
    margin-bottom: 0;
  }

  color: #fff;
  // display: flex;
  // justify-content: flex-start;
  // align-items: flex-start;

  .lefttop {
    // border: 1px solid #fff;
    // border-radius: 10px;
    background: rgba(156, 165, 236, 0.1);
    padding: 30px;
    margin-bottom: 20px;
    box-sizing: border-box;

    .balances {
      padding-top: 35px;
      display: flex;
      justify-content: flex-start;
      align-items: center;

      img {
        padding: 0 30px;
      }
    }

    .el-icon-question {
      font-size: 230%;
      color: #dddddd;
    }
  }

  @media screen and(max-width:1200px) {
    .rightt {
      margin-left: 0 !important;
    }
  }
  @media screen and(min-width:700px) and(max-width:900px) {
    .rightt {
      width: 98% !important;
    }
  }
  @media screen and(max-width:500px) {
    .rightt {
      width: 98% !important;
    }
  }
  .rightt {
    // border: 1px solid #fff;
    // border-radius: 10px;
    padding: 30px;
    margin-left: 16px;
    height: 625px;
    box-sizing: border-box;
    width: 420px;
    background: rgba(156, 165, 236, 0.1);

    .yaoqingma {
      width: 240px;
      height: 240px;
      background: url("../assets/qr_code.png") center center no-repeat;
      background-size: 100% 100%;
      box-sizing: border-box;
      padding: 25px;
      margin: 25px auto;

      .invitation-img-box {
        width: 190px;
        height: 190px;
        overflow: hidden;
        .invitation-img {
          width: 100%;
          height: 100%;
        }
      }

      // #qrcode {
      //   width: 154px;
      //   margin: 0px auto 0;
      // }
    }

    .zz-About {
      display: flex;
      justify-content: space-between;
      align-items: center;

      img {
        height: 20px;
        cursor: pointer;
      }
    }
  }

  .fr {
    float: right;
  }

  .el-form-item__label {
    color: #fff;
    font-weight: normal;
  }
}

#withdrawal-post {
  position: absolute;
  left: 50%;
  bottom: 5%;
  transform: translateX(-50%);
}

.bt-group {
  margin: 0 auto;
  height: 40px;
  // overflow: hidden;
  display: flex;
  justify-content: space-between;
  width: 260px;
  // .tixian {
  //   margin-right: 15px;
  // }

  .tixian,
  .tidian {
    display: inline-block;
    vertical-align: middel;
  }
  .tidian {
    margin-left: -30px;
  }
}

.swal2-title {
  width: 100%;
  padding-left: 16px;
  font-size: 26px;
  text-align: left;
}

.swal2-html-container {
  padding: 0 20px;

  p {
    text-align: left;
  }
}
.lables {
  padding: 0 60px;
}
.lablesb {
  padding: 0 30px;
}
.el-table th > .cell {
  margin-bottom: 15px !important;
}
// 体现部分
#cashback {
  background: rgba(156, 165, 236, 0.1);
  padding: 30px;
  min-height: 450px;
}
.CB_title {
  font-size: 12px;
  display: flex;
  justify-content: space-around;
  width: 90%;
  margin: 0 auto;
  border-bottom: 1px solid hsla(0, 0%, 100%, 0.3);
}
.CB_title li {
  width: 30%;
  box-sizing: border-box;
  text-align: center;
  padding: 15px 0 15px 0;
}
.CB_content {
  font-size: 12px;
  display: flex;
  justify-content: space-around;
  border-bottom: 1px solid hsla(0, 0%, 100%, 0.3);
  width: 90%;
  margin: 0 auto;
  transition-duration: 0.1s;
}
.CB_content:hover {
  background: #12102f;
}
.CB_content span {
  display: inline-block;
  width: 30%;
  text-align: center;
  padding: 10px 0 10px 0;
}
.Recordcontent {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  background-color: #182133;
}
.R_back {
  background: linear-gradient(90deg, #f3c304, #ffe682);
  width: 80px;
  height: 35px;
  border-radius: 5px;
  text-align: center;
  line-height: 35px;
  color: black;
  float: right;
  margin: 33px 76px 0 0;
}
.lablesb-record {
  text-decoration: underline !important;
  cursor: pointer;
  color: #b9babd !important;
  margin-top: -6px;
  padding-right: 5px;
}
.lablesb-record:hover {
  color: #fff !important;
}
.copyLink {
  text-decoration: underline !important;
  cursor: pointer;
  color: #b9babd !important;
  margin-top: -2px;
}
.copyLink:hover {
  color: #fff !important;
}
.invite {
  text-decoration: underline;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Information.vue